import axios from "axios";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./Products.css";

export default function Products() {
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let [product,setproduct]=useState([]);
  let [category,setCategory]=useState([]);

  let[errorMessage,setErrorMessage]=useState("")
  let[vin,setvin]=useState("")

  
  const validateVIN = (vin) => {
    const vinRegex = /^[A-HJ-NPR-Z0-9]*$/i;
    if (!vinRegex.test(vin)) {
      setErrorMessage(
        "VIN must contain only 17 letters and numbers, excluding I, O, and Q."
      );
    } else if (vin.length === 17) {
      setErrorMessage("");
    } else {
      setErrorMessage(
        "VIN must contain only 17 letters and numbers, excluding I, O, and Q."
      );
    }
  };
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setvin(inputValue);
    validateVIN(inputValue);
  };

  
async function addProduct() {
  let name = document.getElementById("nameofProduct").value;
  let description = document.getElementById("description").value;
  let price = document.getElementById("price").value;
  let category = document.getElementById("category").value;
  let images = document.getElementById("images").files;
  let model = document.getElementById("model").value;
  let year = document.getElementById("year").value;
  let agency = document.getElementById("agency").value;
  let carEngine = document.getElementById("carEngine").value;
  const warranty =
      document.querySelector('.dataa input[name="warranty"]:checked')?.id ===
      "warranty"
        ? true
        : false;
        const isForSpecificCar =
        document.querySelector('.specific input[name="isForSpecificCar"]:checked')?.id ===
        "warranty"
          ? true
          : false

  if (
    !name ||
    !price ||
    !description ||
    !category ||
    images.length === 0
  ) {
    Swal.fire({
      icon: "warning",
      title: "you must enter at least five input for product and choose ",
      confirmButtonText: "Ok",
    });
    return;
  }

  let formData = new FormData();
  formData.append("name", name);
  formData.append("description", description);
  formData.append("price", price);
  formData.append("category", category);
  formData.append("isForSpecificCar", isForSpecificCar);
  formData.append("carEngine", carEngine);
  formData.append("carDetails[model]", model);
  formData.append("carDetails[year]", year);
  formData.append("carDetails[agency]", agency);
  formData.append("carDetails[warranty]", warranty);
  
  const validExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

  for (let i = 0; i < images.length; i++) {
    let fileName = images[i].name.toLowerCase();
    let fileExtension = fileName.split(".").pop();
    if (!validExtensions.includes(fileExtension)) {
      Swal.fire({
        icon: "warning",
        title:
          "Please upload an image in a supported format only(jpg, jpeg, png, gif, bmp, webp).",
        confirmButtonText: "ok",
      });
      return;
    }
    formData.append("productImage", images[i]);
  }

  try {
    const response = await axios.post(
      "https://vehex-production.up.railway.app/product/addProduct",
      formData,
      { headers }
    );

    if (response.data.message === "Product added successfully") {
      Swal.fire({
        icon: "success",
        title: "Product added successfully",
        confirmButtonText: "Ok",
      });
    }
    console.log(response.data);
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
    Swal.fire({
      icon: "error",
      title: "error",
      text: "Please, try again!",
      confirmButtonText: "ok",
    });
  }
}

async function getProducts() {
  try {
    let res = await axios.get("https://vehex-production.up.railway.app/product/getAllProducts");
   setproduct(res.data.products)
  } catch (error) {
    console.error(
      
      error.response ? error.response.data : error.message
    );
    
  }
}

async function deleteProduct(id) {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        let response = await axios.delete(
          `https://vehex-production.up.railway.app/product/deleteProduct/${id}`,
          { headers }
        );
        console.log(response)

        if (response.data.message === "Product deleted successfully") {
          Swal.fire({
            title: "The Product has been deleted.",
            icon: "success",
            confirmButtonColor: "#3085d6",
          });
          getProducts();

        }
      } catch (error) {
        console.error("Error deleting Product:", error);
        Swal.fire({
          title: "Error!",
          text: "There was an issue deleting the Product.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    }
  });
}
async function getCategoryId() {
  try {
    let res = await axios.get("https://vehex-production.up.railway.app/category");
   setCategory(res.data.categories)
  } catch (error) {
    console.error(
      
      error.response ? error.response.data : error.message
    );
    
  }
}


useEffect(()=>{
  getProducts()
  getCategoryId();

})

console.log(product);




  return (
    <>
      <form className="ProductForm overflow-x-auto mb-5" id="productForm" onSubmit={(e) => e.preventDefault()}>
        <h1 className="heading">Add Product</h1>
        <div className="d-grid">
          <div>
            <label
              htmlFor="nameofProduct"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Name
            </label>
            <input
              type="text"
              name="nameofProduct"
              id="nameofProduct"
              className="form-control fs-5 mb-2"
            />

            <label
              htmlFor="description"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Description
            </label>
            <input
              type="text"
              name="description"
              id="description"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="price" className="mb-1 fs-5 fw-500 main-color">
              Price
            </label>
            <input
              type="number"
              name="price"
              id="price"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="category" className="mb-1 fs-5 fw-500 main-color">
              Category
            </label>
            <select
              name="category"
              id="category"
              className="form-control fs-5 mb-3"
            >
            <option value=""></option>
            {category.map((category) => (
              <option key={category._id} value={category._id}>
                {category._id}
              </option>
            ))}
           </select>

              <label htmlFor="files" class="fw-bold main-color">Upload Imgs</label>
                <input
                  type="file"
                  id="images"
                  name="carImage"
                  className="form-control mb-3"
                  multiple
                  required
                />
                <p class="fw-bold fs-6 text-black">Please add from 2 to 4 imgs</p>
                
          </div>
          {/* ========================================== */}
          <div>
            <label htmlFor="carEngine" className="mb-1 fs-5 main-color fw-500">
              Car Engine
            </label>
            <input
              type="text"
              name="carEngine"
              id="carEngine"
              className="form-control fs-5 mb-2"
              placeholder="for Example: 1HGBH41JXMN109186"
              value={vin}
              onChange={handleInputChange}
            />
            {errorMessage && (
                  <p className="bg-danger fs-6 text-white py-2 px-1 rounded">
                    {errorMessage}
                  </p>
                )}

            <label htmlFor="model" className="mb-1 fs-5 main-color fw-500">
              Model
            </label>
            <input
              type="text"
              name="model"
              id="model"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="year" className="mb-1 fs-5 main-color fw-500">
              year
            </label>
            <input
              min="1980"
              max="2024"
              type="number"
              name="year"
              id="year"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="agency" className="mb-1 fs-5 main-color fw-500">
              Agency
            </label>
            <input
              type="text"
              name="agency"
              id="agency"
              className="form-control fs-5 mb-2"
            />

            <div className="specific mb-2 d-flex align-items-center justify-content-start gap-3">
              <label
                htmlFor="isForSpecificCar"
                className=" fs-5 fw-500 main-color"
              >
                isForSpecificCar
              </label>

              <div
                className="d-flex align-items-center gap-3"
                id="isForSpecificCar"
              >
                <div className="one">
                  <label htmlFor="true" className="  fs-5">
                    True
                  </label>
                  <input
                    type="radio"
                    className="ms-2"
                    id="true"
                    name="isForSpecificCar"
                  />
                </div>
                <div className="two d-flex align-items-center">
                  <label htmlFor="false" className="  fs-5">
                    False
                  </label>
                  <input
                    type="radio"
                    className="ms-2"
                    id="false"
                    name="isForSpecificCar"
                  />
                </div>
              </div>
            </div>

            <div className="dataa d-flex align-items-center justify-content-start gap-3">
              <label htmlFor="warranty" className=" fs-5 fw-500 main-color">
                Warranty
              </label>

              <div className="d-flex align-items-center gap-3" id="warranty">
                <div className="one">
                  <label htmlFor="warrantytrue" className="  fs-5">
                    True
                  </label>
                  <input
                    type="radio"
                    className="ms-2"
                    id="warrantytrue"
                    name="warranty"
                  />
                </div>
                <div className="two d-flex align-items-center">
                  <label htmlFor="warrantyfalse" className="  fs-5">
                    False
                  </label>
                  <input
                    type="radio"
                    className="ms-2"
                    id="warrantyfalse"
                    name="warranty"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          type="submit"
          onClick={() => addProduct()}
          className=" fs-5 mt-2 fw-500 "
        >
          Add Product
        </button>
      </form>

      <div className=" overflow-x-auto">
        {product?.length>0?<>        <table className=" table table-striped">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Description</th>
              <th>Price</th>
              <th>Category</th>
              <th>Car Engine</th>
              <th>Model</th>
              <th>year</th>
              <th>Agency</th>
              <th>Warranty</th>
              <th>Specific Car</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {product.map((product) => (
          <tr key={product._id}>
            <td>
              <img src={product?.image[0]?.secure_url} width={70} alt="Img" />
            </td>
            <td> {product?.name || "______"}</td>
            <td>{product?.description || "______"}</td>

            <td>{product?.price || "______"}</td>
            <td>{product?.category.name || "______"}</td>
            <td>{product?.carEngine || "______"}</td>
            <td>{product?.carDetails?.model || "______"}</td>
            <td>{product?.carDetails?.year || "______"}</td>
            <td>{product?.carDetails?.agency || "______"}</td>
            <td>{product?.carDetails?.warranty? "true" : "False"}</td>
            <td>{product?.carDetails?.isForSpecificCar? "true" : "False"}</td>
            
            <td>
              <button
                className="btn btn-danger"
                onClick={() => deleteProduct(product._id)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
          </tbody>
        </table></>:<div className="main-color fs-5 fw-500 text-center">No Product Found </div>}

      </div>
    </>
  );
}
